module.exports = "/_next/static/images/konfhubBluelogo1-b50f28367dc0a8b1680b715ba5a18585.png";